import { render, staticRenderFns } from "./production-task-detail.vue?vue&type=template&id=0e3bcd08"
import script from "./production-task-detail.vue?vue&type=script&lang=js"
export * from "./production-task-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports